import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { sendInviteItSupportRequest } from "../redux/actions";
import FormContainer from "./FormContainer";
import { AppState } from "../redux/types";
import UserInviteForm from "./UserInviteForm";
import { localePath } from "../i18n/config";

const ITSupportForm = () => {
  const user = useSelector((state: AppState) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (user && !user.isAdmin) {
      history.push(localePath("kirjaudu"));
    }
  }, [dispatch, history, user]);

  const handleSendInvite = (data: any) => {
    const _data = {
      ...data,
      isNurse: false,
    };
    dispatch(sendInviteItSupportRequest(_data));
    history.push("/admin/it_support");
  };

  return (
    <FormContainer>
      <h1 className="user-form-header">Lisää uusi IT-tuki</h1>{" "}
      {/* Add New IT Support */}
      <UserInviteForm onSendInvite={handleSendInvite} />
    </FormContainer>
  );
};
export default ITSupportForm;
